import { toast } from 'react-toastify';

const AUTH_STATE = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  LOGGED_OUT: 'LOGGED_OUT'
};

class AuthStateManager {
  constructor() {
    this.currentState = AUTH_STATE.LOGGED_OUT;
    this.isHandlingTransition = false;
    this.hasShownNotification = false;
  }

  reset() {
    console.log('AuthStateManager: reset called');
    this.currentState = AUTH_STATE.LOGGED_OUT;
    this.isHandlingTransition = false;
    this.hasShownNotification = false;
  }

  setActive() {
    console.log('AuthStateManager: setActive called');
    this.currentState = AUTH_STATE.ACTIVE;
    this.isHandlingTransition = false;
    this.hasShownNotification = false;
  }

  handleExpired() {
    console.log('AuthStateManager: handleExpired called', {
      currentState: this.currentState,
      isHandlingTransition: this.isHandlingTransition,
      hasShownNotification: this.hasShownNotification
    });

    if (this.currentState === AUTH_STATE.EXPIRED || this.isHandlingTransition) {
      console.log('AuthStateManager: handleExpired - already handling or expired');
      return false;
    }

    this.isHandlingTransition = true;
    this.currentState = AUTH_STATE.EXPIRED;

    if (!this.hasShownNotification) {
      console.log('AuthStateManager: handleExpired - dispatching event');
      this.hasShownNotification = true;
      window.dispatchEvent(new CustomEvent('authStateChanged', {
        detail: { state: AUTH_STATE.EXPIRED }
      }));
    }

    return true;
  }

  handleLogout() {
    console.log('AuthStateManager: handleLogout called', {
      currentState: this.currentState,
      isHandlingTransition: this.isHandlingTransition,
      hasShownNotification: this.hasShownNotification
    });

    if (this.currentState === AUTH_STATE.LOGGED_OUT || this.isHandlingTransition) {
      console.log('AuthStateManager: handleLogout - already handling or logged out');
      return false;
    }

    this.isHandlingTransition = true;
    this.currentState = AUTH_STATE.LOGGED_OUT;

    if (!this.hasShownNotification) {
      console.log('AuthStateManager: handleLogout - showing notification');
      this.hasShownNotification = true;
      toast.info('You have been logged out');
      window.dispatchEvent(new CustomEvent('authStateChanged', {
        detail: { state: AUTH_STATE.LOGGED_OUT }
      }));
    }

    return true;
  }

  isExpiredOrLoggedOut() {
    return this.currentState === AUTH_STATE.EXPIRED || 
           this.currentState === AUTH_STATE.LOGGED_OUT;
  }
}

export const authStateManager = new AuthStateManager();
export { AUTH_STATE }; 